export enum ArtworkSummaryTheme {
  Auction = 'auction',
  BuyNow = 'buyNow',
  MakeOffer = 'makeOffer',
}
